(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('multipleFileUpload', ['FileUploader', '$rootScope', '$http', 'MultipleFileUploadBroadcast', MultipleFileUploadFn]);

    //multiple file-uploader
    function MultipleFileUploadFn(FileUploader, $rootScope, $http, MultipleFileUploadBroadcast) {

        var directive = {
            link: {
                // initialize directive
                pre: function (scope) {
                    scope.uploader = new FileUploader({
                        headers: {
                            'Authorization': $http.defaults.headers.common['Authorization']
                        },
                        url: scope.uploadUrl,
                        autoUpload: true
                    });
                },
                post: link
            },
            scope: {
                uploadUrl: "=",
                onClearAll: "="
            },
            restrict: 'E',
            replace: true,
            templateUrl: '/app/global/templates/rf-global-multiple-file-upload.template.html'
        };

        return directive;

        function link(scope, element) {

            var persistedFileNames = [];

            // alert if an error occured
            scope.uploader.onErrorItem = function (item, response, status, headers) {
                alert("Failed to upload file: " + status + " " + response);
            };

            // remove wrapper
            scope.removeFile = function (item) {
                // remove file
                if (removeFile(item.$$hashKey)) {
                    item.remove();
                    removeFromFileList(item.$$hashKey);
                }
            };

            // remove all wrapper
            scope.removeAllFiles = function () {
                var flag = true;
                // remove each file
                angular.forEach(scope.uploader.queue, function (value, key) {
                    // remove file
                    flag = flag ? removeFile(value.$$hashKey) : false;

                    if (flag) {
                        removeFromFileList(value.$$hashKey);
                    }
                });
                // clear uploader queue
                if (flag)
                    scope.uploader.clearQueue();
            };

            // uploaded success event
            scope.uploader.onSuccessItem = function (fileItem, response, status, headers) {
                // set persisted file name
                if (response !== null && response.length > 0) {
                    persistedFileNames[fileItem.$$hashKey] = response[0];
                    updateFiles();
                }
            };

            // get filelist
            scope.fileList = function () {
                var list = [];

                // get all filenames
                angular.forEach(scope.uploader.queue, function (value, key) {
                    list.push(persistedFileNames[value.$$hashKey]);
                });

                return list;
            };

            // check if to clear all
            scope.$watch('onClearAll', function (flag) {
                if (flag) {
                    scope.removeAllFiles();
                }
            });

            // function to remove the persisted file
            function removeFile(hashKey) {
                var ret = false;
                // get persisted file name
                var fileName = persistedFileNames[hashKey];
                // check if exists and remove from filesystem
                if (typeof fileName !== 'undefined' || fileName !== null || fileName.trim() !== '') {
                    // remove from filesystem
                    ret = $http.delete(scope.uploadUrl + '/' + fileName).then(function (response) {
                        return response !== null;
                    });
                }
                return ret;
            }

            // function to remove from internal list
            function removeFromFileList(hashKey) {
                delete persistedFileNames[hashKey];
                updateFiles();
            }

            // function to send updateFile event
            function updateFiles() {
                $rootScope.$broadcast(MultipleFileUploadBroadcast.UpdateFileList, persistedFileNames);
            }
        }
    }
})();